const attributesToIgnore = ['gtm.uniqueEventId'];

const deepEquals = (x, y) => {
  return x && y && typeof x === 'object' && typeof y === 'object'
    ? Object.keys(x).length === Object.keys(y).length &&
        Object.keys(x).reduce(function (isEqual, key) {
          return isEqual && deepEquals(x[key], y[key]);
        }, true)
    : x === y;
};

const removeGtmAttributes = (object) => {
  if (!object || typeof object !== 'object') {
    return object;
  }
  const clone = JSON.parse(JSON.stringify(object));
  attributesToIgnore.forEach((attributeToIgnore) => {
    delete clone[attributeToIgnore];
  });
  return clone;
};

const addToDataLayer = (payload) => {
  try {
    if (!window.customEvents) {
      window.customEvents = [];
    }
    if (!window.dataLayer) {
      window.dataLayer = [];
    }
    const lastEvent = removeGtmAttributes(
      window.customEvents[window.customEvents.length - 1]
    );
    if (!deepEquals(lastEvent, payload)) {
      // payload['gtm.uniqueEventId'] = Math.random(); //uncomment this for testing on localhost
      window.dataLayer.push(payload);
      window.customEvents.push(payload);
    }
  } catch (e) {
    console.log(e);
  }
};

const transformItems = (menuItems, categories, restaurant) => {
  const items = JSON.parse(JSON.stringify(menuItems));
  items?.forEach((item) => {
    if (item) {
      item.categoryIds?.forEach((categoryId) => {
        const categoryName = categories?.find(
          (category) => category.id === categoryId
        )?.name;
        if (categoryName) {
          if (!item.item_category) {
            item.item_category = []
          }
          item.item_category.push(categoryName)
        }
      });
      item.brand = restaurant.name;
      if (!item.item_category) {
        item.item_category = 'All'
      }
      if (item.menuItemId) {
        item.item_id = item.menuItemId
        delete item.menuItemId
      }
      if (item.costForEmployees) {
        item.price = item.costForEmployees
        delete item.costForEmployees
      }
    }
  });
  return items;
};

const userNavigate = (text) => {
  const payload = {
    event: 'navigation',
    link_text: text,
    link_url: window.location.href,
  };
  addToDataLayer(payload);
};

const userNavigateVirtual = (location, title) => {
  const payload = {
    event: 'virtual_pageview',
    page_location: location,
    page_title: title,
  };
  addToDataLayer(payload);
};

const viewItemsList = (items, categories, restaurant) => {
  const payload = {
    event: 'view_item_list',
    ecommerce: {
      currency: 'MKD',
      items: transformItems(items, categories, restaurant),
    },
  };
  addToDataLayer(payload);
};

const viewRestaurant = (name, id, status) => {
  const payload = {
    event: 'view_restaurant',
    restaurant_name: name,
    restaurant_id: id,
    restaurant_status: status,
    city: name.includes('Bitola') ? 'Bitola' : 'Skopje',
  };
  addToDataLayer(payload);
};

const createOrder = (
  orderId,
  mainMenuItem,
  sideMenuItem,
  extraMenuItems,
  categories,
  restaurant
) => {
  let totalEmployeeCost = mainMenuItem.costForEmployees;
  if (extraMenuItems) {
    extraMenuItems.forEach(function (item) {
      totalEmployeeCost += item.costForEmployees;
    });
  }
  let allOrderItems = [];
  allOrderItems = allOrderItems.concat(
    mainMenuItem,
    sideMenuItem,
    extraMenuItems
  );
  const payload = {
    event: 'purchase',
    transaction_id: orderId,
    ecommerce: {
      currency: 'MKD',
      value: totalEmployeeCost,
      items: transformItems(allOrderItems, categories, restaurant),
    },
  };
  addToDataLayer(payload);
};

const cancelOrder = (orderElement) => {
  const payload = {
    event: 'cancel_order',
    transaction_id: orderElement.childNodes[1].innerText,
    value: orderElement.childNodes[5].innerText,
    restaurant_name: orderElement.childNodes[2].innerText,
    item_name: orderElement.childNodes[3].innerText,
  };
  addToDataLayer(payload);
};

const addToCart = (item, categories, restaurant) => {
  const payload = {
    event: 'add_to_cart',
    ecommerce: {
      currency: 'MKD',
      value: item.costForEmployees,
      items: transformItems([item], categories, restaurant),
    },
  };
  addToDataLayer(payload);
};

const TrackingService = {
  userNavigate,
  userNavigateVirtual,
  viewItemsList,
  viewRestaurant,
  createOrder,
  cancelOrder,
  addToCart,
};

export default TrackingService;
